import axios, { } from 'axios'
import config from '../config'
import qs from 'qs'
import systemApi from './system'
import sessionApi from './session'
import courseApi from './course'
import utils from "../utils";
//import {Toast} from "antd-mobile";
import { store } from "../store";
import { LOGOUT_REQUESTED } from "../store/user/actionTypes";
import history from './../router/history'

export interface ApiDataMeta {
  total: number,
  pageIndex: number,
  totalPage: number,
  pageSize: number,
}

export interface ApiResponse<T = any> {
  data: T,
  success: boolean,
  errorCode: number,
  error: string,
  meta?: ApiDataMeta,
  status?: string,
  message?: string,
}

const api = axios.create({
  baseURL: config.host,
  withCredentials: true,
  // transformRequest: [(data) => JSON.stringify(data.data)],
  headers: {
    // 'Content-Type': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  },
  // paramsSerializer: params => {
  //     return qs.stringify(params, { indices: false })
  //     // return qs.stringify(params,{indices: false,arrayFormat: 'indices', allowDots: true})
  // }
  transformRequest: [
    (data, headers) => {
      if (!data) return data

      const contentType = headers['Content-Type'] || ''
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return qs.stringify(data)
      } else if (contentType.indexOf('application/json') > -1) {
        return JSON.stringify(data)
      } else {
        return data
      }
    },
  ],
});

// http request 拦截器
api.interceptors.request.use(
  config => {
    if (config.data) {
      if (config.data.constructor === FormData) {
        config.headers['Content-Type'] = 'multipart/form-data'
      }
    }

    return config;
  },
  err => {
    return Promise.reject(err);
  }
)

// http response 拦截器
api.interceptors.response.use(
  response => {
    if (response.data.status !== undefined || response.data.success !== undefined) {
      if (response.data.status === 'success' || response.data.success === true) {
        return response.data
      } else {
        const message = response.data.msg || response.data.message
        utils.alert(message || ('网络错误: 01;' + JSON.stringify(response.data)), {
          title: '错误'
        })
      }
      return Promise.reject(response.data);
    } else {
      return response.data;
    }
  },
  error => {
    if (error
      && error.response
      && error.response.status === 401) {
      if (history.location.pathname !== '/pc') {
        history.replace('/pc')
      }
      store.dispatch({
        type: LOGOUT_REQUESTED,
      })
      return Promise.reject(error)
    }
    
    if (error.response.status === 500) {
      utils.alert(`${error.response.data.message ? error.response.data.message : JSON.stringify(error.response.data)}`)
      return Promise.reject(error)
    }

    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    // console.log(error);
    // console.log(error.response);
    // console.log(error.message);
    
    if (!error) {
      utils.alert(`网络错误: 04`)
    } else if (error.response) {
      utils.alert(`${error.response ? JSON.stringify(error.response) : ''}`)
    } else if (error.message) {
      utils.alert(`网络错误: 02 (${error.message})`)
    } else {
      utils.alert(`网络错误: 03 (${error})`)
    }
    return Promise.reject(error);
  }
)

export { sessionApi, systemApi, courseApi }

export default api